export const getActividadEconomicaModel = () => ({ iIdActividadEconomica: 0 });
